import TableComponent from '../../../../../../../components/stories/organisms/table'
import { TableProjectsPaginationContainer } from '../../../../../styled-component'

const CompanyProjectsTablePagination = ({ pagination }) => {
  if (!pagination?.totalElements) return null

  return (
    <TableProjectsPaginationContainer>
      <TableComponent.Pagination pagination={pagination} selectedItems={null} />
    </TableProjectsPaginationContainer>
  )
}

export default CompanyProjectsTablePagination
